export default {
    methods: {
    toggle_active: function(x) {
      // console.log('toggle', '#tag_' + x);
      $('#tag_' + x).toggleClass('btn-link');
      $('#tag_' + x).toggleClass('btn-success');
    },
}
}


// WEBPACK FOOTER //
// ./src/mixins/toggle_active.js